// Utility Functions
export default class UtilityFunctions {
  constructor() {
    this.init();
  }

  init() {
    // Make functions globally available
    window.formatNumber = this.formatNumber.bind(this);
    window.formatCurrency = this.formatCurrency.bind(this);
    window.loadCurrentPeriodData = this.loadCurrentPeriodData.bind(this);
  }

  // Function to format numbers with commas
  formatNumber(num) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    }).format(num);
  }

  // Function to format currency values
  formatCurrency(num) {
    return new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    }).format(num);
  }

  // Function to load current period data (legacy compatibility)
  loadCurrentPeriodData() {
    if (window.currentPeriodDataManager) {
      window.currentPeriodDataManager.loadCurrentPeriodData();
    }
  }
}